import { PrimaryLink, SecondaryLink } from "./Links";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useState } from "react";

const SLIDES = [
  {
    image: "/bg-hero-1.webp",
    title: "Tu hogar no solo es donde vivís, es donde construís tus sueños",
  },
  {
    image: "/bg-hero-2.webp",
    title: "Un mundo en servicios",
  },
  {
    image: "/bg-hero-3.webp",
    title: "Soluciones confiables para cada rincón de tu hogar",
  },
];

const Slider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <section
      id="hero"
      className="relative flex flex-col items-center w-full mt-16 bg-white/70 overflow-hidden"
      style={{ height: "calc(100vh - 58px - 64px)" }}
    >
      <div className="container h-full px-6 mx-auto flex flex-col justify-center z-10 py-20 md:py-32 lg:py-36">
        <div className="">
          <h1 className="text-3xl tracking-tight sm:text-5xl xl:text-6xl text-secondary flex items-end">
            {SLIDES[activeIndex].title}
          </h1>
          <p className="max-w-[600px] py-4 text-secondary md:text-lg text-base">
            Más de 30 años acompañándote. Accede a una red de profesionales verificados para tu hogar.
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-start gap-4 md:gap-8 text-sm text-secondary pb-4">
          <div className="flex items-center gap-1">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#1d2d44"
              className="h-5 w-5 text-secondary"
            >
              <path
                d="M8.5 12.5L10.5 14.5L15.5 9.5"
                stroke="#1C274C"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                stroke="#1C274C"
                stroke-width="1.5"
                stroke-linecap="round"
              ></path>
            </svg>
            <span>Profesionales verificados</span>
          </div>
          <div className="flex items-center gap-1">
            <svg
              className="h-5 w-5 text-secondary"
              fill="#1d2d44"
              viewBox="0 0 32 32"
            >
              <path d="M16.114-0.011c-6.559 0-12.114 5.587-12.114 12.204 0 6.93 6.439 14.017 10.77 18.998 0.017 0.020 0.717 0.797 1.579 0.797h0.076c0.863 0 1.558-0.777 1.575-0.797 4.064-4.672 10-12.377 10-18.998 0-6.618-4.333-12.204-11.886-12.204zM16.515 29.849c-0.035 0.035-0.086 0.074-0.131 0.107-0.046-0.032-0.096-0.072-0.133-0.107l-0.523-0.602c-4.106-4.71-9.729-11.161-9.729-17.055 0-5.532 4.632-10.205 10.114-10.205 6.829 0 9.886 5.125 9.886 10.205 0 4.474-3.192 10.416-9.485 17.657zM16.035 6.044c-3.313 0-6 2.686-6 6s2.687 6 6 6 6-2.687 6-6-2.686-6-6-6zM16.035 16.044c-2.206 0-4.046-1.838-4.046-4.044s1.794-4 4-4c2.207 0 4 1.794 4 4 0.001 2.206-1.747 4.044-3.954 4.044z"></path>
            </svg>
            <span>CABA</span>
          </div>
        </div>
        <div className="flex flex-col gap-4 md:gap-6 md:flex-row mt-4">
          <PrimaryLink href="/asociarme">Asociarme</PrimaryLink>
          <SecondaryLink href="/servicios">Solicitar un técnico</SecondaryLink>
        </div>
      </div>

      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop
        className="!absolute inset-0 h-full w-full"
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      >
        {SLIDES.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="flex flex-col items-center w-full h-full bg-white/70">
              <img
                src={slide.image}
                alt={slide.title}
                className="absolute h-full w-full top-0 object-cover -z-20"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Slider;